import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { PickList } from "primereact/picklist";
import * as Fa from "react-icons/fa";
import { Link } from "react-router-dom";
import { fetchData } from "../../../Services/GlobalService";
import { downloadExcelDateFormat } from "../../../Services/GlobalFunction/DownLoadExcel";
import { MultiSelect } from "primereact/multiselect";
import Loader from "../../../Components/Loader";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import Axios from "../../../API/Axios";

export type SegmentType = "B2C" | "HDSSD" | "Industrial DB" | "IDB";

function useDebounce<T extends (...args: any[]) => void>(
  fn: T,
  delay: number = 500,
): (...args: Parameters<T>) => void {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const fnRef = useRef<T>(fn);
  useEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  return useCallback(
    (...args: Parameters<T>) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        fnRef.current(...args);
      }, delay);
    },
    [delay],
  );
}

const DBSIPReport: React.FC = () => {
  const UserId = localStorage.getItem("UserId")?.toString();

  const [segment, setSegment] = useState<SegmentType>("B2C");
  const [distLoading, setDistLoading] = useState<boolean>(false);

  const [selectedDivision, setSelectedDivision] = useState<any>(null);
  const [selectedRegion, setSelectedRegion] = useState<any>(null);
  const [selectedState, setSelectedState] = useState<any>(null);
  const [selectedConstruct, setSelectedConstruct] = useState<any>(null);
  const [division, setDivision] = useState<any[]>([]);
  const [distributor, setDistributor] = useState<any[]>([]);
  const [selectedDistributor, setSelectedDistributor] = useState<any>(null);

  const [sourceDistributors, setSourceDistributors] = useState<any[]>([]);
  const [targetDistributors, setTargetDistributors] = useState<any[]>([]);
  const [constructOptions, setConstructOptions] = useState<any[]>([]);
  const [regionOptions, setRegionOptions] = useState<any[]>([]);
  const [stateOptions, setStateOptions] = useState<any[]>([]);

  const ControllerName = "masters/Distributer/TownDistMap_ReHistory";
  const ControllerSegAudit = "masters/Customer/CustomerSegmentAudit";
  const Controllerconstruct = "DBScoreCard/LBMBrandAndBrandMapping";
  const ControllerReport = "DBSIPReport";

  const EndPoint = {
    PopulateRegion: "PopulateRegion",
    PopulateState: "PopulateState",
    PopulateAllDistributor: "PopulateAllDistributor",
    GetTwnDistHistoryExcel: "GetTwnDistHistoryExcel",
    PopulateDivision: "PopulateDivision",
  };

  const EndPointCustSeg = {
    GetFilterDistributor: "GetFilterDistributor",
  };
  const Endpointconstruct = {
    FetchingConstructData: "FetchingConstructData",
  };
  const EndpointReport = {
    DonwloadDBSIPReport: "DonwloadDBSIPReport",
  };

  const [downloadLoading, setDownloadLoading] = useState(false);

  const itemTemplatePanelDist = (item: any) => <span>{item.COMP_NAME}</span>;

  const handleDownload = async () => {
    if (!selectedConstruct) {
      toast.warn("Please select a Construct before downloading the report.");
      return;
    }
    if (!targetDistributors || targetDistributors.length === 0) {
      toast.warn(
        "Please select at least one distributor before downloading the report.",
      );
      return;
    }

    setDownloadLoading(true);

    const distlist = targetDistributors
      .map((dist: any) => dist.COMP_ID)
      .join("~");

    try {
      const queryParams = {
        Stream: segment ?? "",
        Pvc_ConstructSeq: "",
        Pvc_ParameterSeq: segment === "B2C" ? "6" : "",
        Pvc_COMP_ID: distlist,
        Pvc_SEQ: (selectedConstruct?.Seq).toString() ?? "",
        ConstractName: selectedConstruct?.Name ?? "",
        TrueUp: "",
      };

      const response = await Axios.post(
        `${ControllerReport}/${EndpointReport.DonwloadDBSIPReport}`,
        queryParams,
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const ticks = Date.now() * 10000 + 621355968000000000;
      let segmentName = segment == "IDB" ? "Industrial" : segment;
      let strExcelReportName =
        `DB_SIP_Data_${segmentName}` +
        "_" +
        new Date()
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .replace(/ /g, "") +
        "_" +
        ticks.toString() +
        ".xlsx";
 
      let fileName = strExcelReportName;
      saveAs(blob, fileName);
      toast.success("Report downloaded successfully.");
    } catch (error:any) {
      toast.warn("No data is found");
      console.log(error?.response?.data?.Message);
    } finally {
      setDownloadLoading(false);
    }
  };

  const populateconstruct = async (channelType: SegmentType = "B2C") => {
    try {
      const fetcgconstruct = await fetchData(
        Controllerconstruct,
        `${Endpointconstruct.FetchingConstructData}`,
        `ChannelType=${channelType}`,
      );
      setConstructOptions(fetcgconstruct?.Data || []);
    } catch (error) {
      console.error("Error fetching construct options:", error);
    }
  };

  const listOfDistributor = async (
    regions: any[] = selectedRegion ?? [],
    states: any[] = selectedState ?? [],
    division: any = selectedDivision,
    distType: any = selectedDistributor,
  ) => {
    if (!regions?.length || !states?.length) return;

    const seledtedregions = regions
      .map((item: any) => `${item.MASK_ID}`)
      .join(",");
    const seledtedstates = states
      .map((item: any) => `${item.mask_id}`)
      .join(",");

    setDistLoading(true);
    try {
      const PopulateDistData = await fetchData(
        "CommonDropdown",
        "DropDownList",
        `UserId=${UserId}&PVCtype=DBSIP_Dist_List&PVCPAYLOAD=${JSON.stringify({
          userid: UserId,
          region: seledtedregions,
          state: seledtedstates,
        })}`,
      );
      setSourceDistributors(PopulateDistData?.Data ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setDistLoading(false);
    }
  };

  const debouncedListOfDistributor = useDebounce(listOfDistributor, 500);
  const stateCallfun = async (selectedregionValus: string) => {
    const PopulateStateRes = await fetchData(
      ControllerName,
      `${EndPoint.PopulateState}`,
      `UserId=${UserId}&strRegionId=${selectedregionValus}`,
    );
    setStateOptions(PopulateStateRes?.Data ?? []);
    setTargetDistributors([]);
  };

  const debouncedStateCallfun = useDebounce(stateCallfun, 400);

  const handleRegion = (e: any) => {
    const selectedRegions = e.value;
    setSelectedRegion(selectedRegions);

    const selectedregionValus = selectedRegions
      .map((item: any) => `${item?.MASK_ID}`)
      .join(",");

    setSelectedState([]);
    setTargetDistributors([]);
    debouncedStateCallfun(
      selectedregionValus === "" ? "All" : selectedregionValus,
    );
  };

  useEffect(() => {
    const populateAllData = async () => {
      try {
        // Fetch all dropdown data concurrently
        const [
          PopulateRgnRes,
          PopulateDivRes,
          PopulateStateRes,
          PopulateDistributorRes,
        ] = await Promise.all([
          fetchData(
            ControllerName,
            `${EndPoint.PopulateRegion}`,
            `UserId=${UserId}`,
          ),
          fetchData(
            ControllerName,
            `${EndPoint.PopulateDivision}`,
            `UserId=${UserId}`,
          ),
          fetchData(
            ControllerName,
            `${EndPoint.PopulateState}`,
            `UserId=${UserId}&strRegionId=All`,
          ),
          fetchData(
            ControllerName,
            "PopulateAllDistributor",
            `UserId=${UserId}`,
          ),
        ]);

        const regionData = PopulateRgnRes?.Data || [];
        const divisionData = PopulateDivRes?.Data || [];
        const stateData = PopulateStateRes?.Data || [];
        const distributorData = PopulateDistributorRes?.Data || [];

        // Persist to state for the UI dropdowns
        setRegionOptions(regionData);
        setSelectedRegion(regionData);
        setDivision(divisionData);
        setSelectedDivision(divisionData[0]);
        setStateOptions(stateData);
        setSelectedState(stateData);
        setDistributor(distributorData);
        setSelectedDistributor(distributorData[0]);
        await listOfDistributor(
          regionData,
          stateData,
          divisionData[0],
          distributorData[0],
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    populateconstruct();
    populateAllData();
  }, []);

  return (
    <main>
      <div className="col-12 mb-5">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mx-0">
                <li className="breadcrumb-item">DB SIP</li>
                <li className="breadcrumb-item active" aria-current="page">
                  DB SIP Report
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-lg-4 col-md-12 col-sm-12">
            <h3 className="py-2">DB SIP Report</h3>
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12">
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn anime-btn"
                onClick={handleDownload}
                disabled={downloadLoading}
              >
                {downloadLoading ? (
                  <>
                    Loading...{" "}
                    <span
                      className="spinner-border spinner-border-sm ms-1"
                      role="status"
                      aria-hidden="true"
                    />
                  </>
                ) : (
                  <>
                    Download Report <Fa.FaDownload className="ms-2" />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        <section className="sales-box">
          {/* Segment radio buttons */}
          <div className="d-flex justify-content-center flex-wrap gap-4 mb-3">
            {(
              [
                { label: "B2C", value: "B2C" },
                { label: "HDSSD", value: "HDSSD" },
                { label: "Industrial DB", value: "IDB" },
              ] as { label: string; value: SegmentType }[]
            ).map((s) => (
              <div key={s.value} className="d-inline-flex align-items-center">
                <RadioButton
                  inputId={`seg-${s.value}`}
                  name="segment"
                  value={s.value}
                  onChange={(e) => {
                    setSegment(e.value);
                    populateconstruct(e.value);
                    setSelectedConstruct(null)
                  }}
                  checked={segment === s.value}
                />
                <label
                  htmlFor={`seg-${s.value}`}
                  className="form-label ms-2 mb-0"
                >
                  {s.label}
                </label>
              </div>
            ))}
          </div>

          {/* Filter panel */}
          <div className="border p-3 rounded">
            <div className="row d-flex justify-content-end align-items-end">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block">
                  <label className="form-label">Region</label>
                  <div className="d-flex align-items-center gap-2">
                    <MultiSelect
                      value={selectedRegion}
                      onChange={(e) => handleRegion(e)}
                      options={regionOptions}
                      selectAllLabel="Select All"
                      optionLabel="REGION_DESC"
                      placeholder="Select Region"
                      className="w-100"
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block">
                  <label className="form-label">State</label>
                  <div className="d-flex align-items-center gap-2">
                    <MultiSelect
                      value={selectedState}
                      onChange={(e) => setSelectedState(e.value)}
                      options={stateOptions}
                      selectAllLabel="Select All"
                      optionLabel="GEOG_DESC1"
                      placeholder="Select State"
                      className="w-100"
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="d-block">
                  <label className="form-label">Distributor Type</label>
                  <div className="d-flex align-items-center gap-2">
                    <Dropdown
                      value={selectedDistributor}
                      onChange={(e) => setSelectedDistributor(e.value)}
                      options={distributor}
                      optionLabel="NAME"
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="text-end">
                  {/* Button calls with current state — debounced to prevent rapid clicks */}
                  <button
                    type="button"
                    className="btn anime-btn"
                    onClick={() => debouncedListOfDistributor()}
                  >
                    Get Distributors
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* PickList */}
          <div className="border rounded bg-white p-3 mt-3">
            <h6 className="text-success mb-3">List of Distributors :</h6>
            <div className="PickListPanel">
              {distLoading ? (
                <Loader />
              ) : (
                <PickList
                  source={sourceDistributors}
                  target={targetDistributors}
                  itemTemplate={itemTemplatePanelDist}
                  sourceHeader="Available Distributors"
                  targetHeader="Selected Distributors"
                  filter
                  filterBy="COMP_NAME"
                  dataKey="COMP_NAME"
                  onChange={(e) => {
                    setSourceDistributors(e.source);
                    setTargetDistributors(e.target);
                  }}
                  sourceStyle={{ height: "250px" }}
                  targetStyle={{ height: "250px" }}
                  showSourceControls={false}
                  showTargetControls={false}
                />
              )}
            </div>
          </div>

          {/* Construct */}
          <div className="border rounded bg-white p-3 mt-3">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12 offset-4">
                <div className="d-block mb-2">
                  <label className="form-label">Construct</label>
                  <Dropdown
                    value={selectedConstruct}
                    onChange={(e) => setSelectedConstruct(e.value)}
                    options={constructOptions}
                    optionLabel="Name"
                    placeholder="Select Construct"
                    className="w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default DBSIPReport;
